module.exports = __webpack_public_path__ + "static/observable-int-552511f23cd6ae0adf3ebce792b5244f.svg";